export const logo = require('./logo.svg');
export const qr = require('./template_qr.jpg');
export const logoPng = require('./logo.png');
export const menuLogo = require('./side-menu-logo.svg');
export const avatar = require('./profile-picture-avatar.png');
